import { z } from 'zod';

import { actionIdSchema } from './chat-ids';

export const resumeActionDecisionSchema = z.object({
    accepted: z.boolean(),
    actionId: actionIdSchema,
    type: z.literal('decision'),
});

export type ResumeActionDecision = z.infer<typeof resumeActionDecisionSchema>;

export const resumeActionInputSchema = z.object({
    actionId: actionIdSchema,
    input: z.string(),
    type: z.literal('input'),
});

export type ResumeActionInput = z.infer<typeof resumeActionInputSchema>;

export const editedProposalSectionSchema = z.object({
    id: z.string(),
    value: z.string(),
});

export type EditedProposalSection = z.infer<typeof editedProposalSectionSchema>;

// Sent alongside the accept `input` action; carries only the fields the user changed.
// The client always sends `sections` (possibly empty). `description` mirrors the backend
// contract but is reserved: nothing in the client emits it (v1 has no description editing).
export const resumeActionEditedContentSchema = z.object({
    actionId: actionIdSchema,
    content: z.object({
        description: z.string().optional(),
        sections: z.array(editedProposalSectionSchema).optional(),
        title: z.string().optional(),
    }),
    type: z.literal('edited-content'),
});

export type ResumeActionEditedContent = z.infer<typeof resumeActionEditedContentSchema>;

export const resumeActionSchema = z.discriminatedUnion('type', [
    resumeActionDecisionSchema,
    resumeActionInputSchema,
    resumeActionEditedContentSchema,
]);

export type ResumeAction = z.infer<typeof resumeActionSchema>;

/** The payload of a resume entry that answers a question; the interrupt's `responseSchema` describes it. */
export const chatResumePayloadSchema = z.object({
    actions: z.array(resumeActionSchema).readonly(),
});

export type ChatResumePayload = z.infer<typeof chatResumePayloadSchema>;
